import {useState, useEffect } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { visualizerActions } from "../../store";
import ProductList from '../ProductList/ProductList';
import DropdownFilter from "../DropdownFilter/DropdownFilter";
import { uiActions } from '../../store';

export default function WallBaseMenu() {
    const dispatch = useDispatch();
    const compareData = useSelector(state => state.visualizer.compareData);
    //all filters currently applied
    const appliedDropdownFilters = useSelector(state => state.visualizer.productDropdownFilters);
    const dropdownFilters = useSelector((state) => state.visualizer.productDropdownFilters);
    const activeSurface = useSelector(state => state.visualizer.activeSurface);
    const appliedProducts = useSelector(state => state.visualizer.appliedProducts);
    const selectedProduct = appliedProducts?.[activeSurface?.location ?? 'chamViz']?.[activeSurface?.name] ?? null;
    
    useEffect(() => {

        let sel = selectedProduct == null ? -1 : selectedProduct.colorway.id;

        document.getElementById(compareData.side).applyByFilter('', '', function (newSel) {
            if (activeSurface?.name === this.name) {
                if(sel != this.sel){
                   return sel
                }else{
                    console.log('sel is the same...')
                }
            }
        });
            
    }, [appliedProducts]);

    const handleProductSelect = function (product) {
       if(!activeSurface)
            return;

        if(!activeSurface.name.toLowerCase().includes('wall')){
            alert('Please choose a compatible surface.');
            return;
        }

        dispatch(visualizerActions.setAppliedProduct({
            location: compareData.side,
            surface: activeSurface.name,
            data: {
                colorway: product,
                selStrings: null,
                size: null,
                install: null,
            },
        }));
    }

    const handleDropdownFilterChange = (e) => {
        const { name, value } = e.target;
        dispatch(visualizerActions.setproductDropdownFilter({
            [name]: value,
        }));

    };

    return (
              <>
            
                <DropdownFilter
                    handleSelect={handleDropdownFilterChange}
                    seriesId="7973"
                    label="Colors"
                    column="name"
                    value={appliedDropdownFilters['name']??-1}
                />
                 <ProductList
                  seriesId="7973"
                  thumbSize={250}
                  handleSelect={handleProductSelect}
                  dropdownFilters={dropdownFilters}
                  searchValue={''}
                />
              </>
            );
}